"use client";

import { useState } from "react";

interface SegmentOption {
  label: string;
  value: string;
  /** Optional badge, e.g. "30%" */
  badge?: string;
}

interface SegmentToggleProps {
  className?: string;
  options?: SegmentOption[];
  defaultValue?: string;
  onChange?: (value: string) => void;
}

export function SegmentToggle({
  className = "",
  options = [
    { label: "Месяц", value: "month" },
    { label: "Год", value: "year", badge: "30%" },
  ],
  defaultValue,
  onChange,
}: SegmentToggleProps) {
  const [active, setActive] = useState(defaultValue ?? options[0]?.value);

  const handleChange = (value: string) => {
    setActive(value);
    onChange?.(value);
  };

  return (
    <div
      className={`bg-[var(--brand-primary-soft)] flex items-center gap-[8px] p-[4px] rounded-[14px] shrink-0 ${className}`}
    >
      {options.map((opt) => (
        <button
          key={opt.value}
          onClick={() => handleChange(opt.value)}
          className={`flex items-center justify-center gap-[8px] rounded-[10px] shrink-0 px-[12px] py-[6px] transition-colors cursor-pointer
            ${active === opt.value ? "bg-white" : "hover:bg-[var(--brand-primary-tint)]"}`}
        >
          <span
            className="[font-family:var(--font-commissioner)] font-medium not-italic text-[14px] leading-[16px] text-[rgba(0,0,0,0.9)] text-center whitespace-nowrap"
            style={{ fontVariationSettings: '"FLAR" 0, "VOLM" 0' }}
          >
            {opt.label}
          </span>
          {opt.badge && (
            <span className="bg-accent-orange flex items-center justify-center px-[8px] py-[2px] rounded-[16px] shrink-0">
              <span
                className="[font-family:var(--font-commissioner)] font-medium not-italic text-[12px] leading-[16px] text-white whitespace-nowrap"
                style={{ fontVariationSettings: '"FLAR" 0, "VOLM" 0' }}
              >
                {opt.badge}
              </span>
            </span>
          )}
        </button>
      ))}
    </div>
  );
}
